import { DatePicker, DatePickerChangeEvent, MultiViewCalendar } from "@progress/kendo-react-dateinputs"
import dayjs from "dayjs"
import { useEffect, useState } from "react"

export const CustomCalendar = (props: any) => {
    const { updateDate } = props
    const [showDate, setShowDate] = useState<boolean>(false)
    const [date] = useState<Date | null>(props.value ? dayjs(props.value).toDate() : null)

    useEffect(() => {
        setShowDate(false)
    }, [date])

    const CustomDatePicker=() =>  (
    <MultiViewCalendar
            {...props}
            views={1}
            value={date}
            topView="decade"
            bottomView="month"
            onChange={(ev: DatePickerChangeEvent) => updateDate(ev.value)} 
            />
    )
    return (
        <DatePicker
            label={props.label}
            disabled={props.disabled}
            onBlur={() => setShowDate(false)}
            value={date}
            onFocus={() => setShowDate(true)}
            show={showDate}
            calendar={CustomDatePicker}
        />
    )
}
